module.exports = __webpack_public_path__ + "img/confetti_3a.b140b5c6.svg";